export default __webpack_public_path__ + "static/media/fourth-item-bg.5fe78528.svg";